import { Component, Injector, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { ApplicationFormQuestionTraverseComponent } from '../../application-form-question-traverse.component';

@Component({
  moduleId: module.id,
  selector: 'iterate-collection',
  templateUrl: './iterate-collection.component.html',
})
export class IterateCollectionComponent extends BaseFormComponent {
  @ViewChildren('arrayChildren') viewChildren: QueryList<ApplicationFormQuestionTraverseComponent>;
  activeElement: number = -1;
  removeIndex: number = -1;
  arrayProp: Array<any> = [];
  linkLabel: string = 'Add Another';

  constructor(protected injector: Injector) {
    super(injector);
    this.activeElement = this.arrayProp.length ? this.arrayProp.length - 1 : 0; // by default open the last element in iterator
  }

  ngOnInit() {
    this.arrayProp = this.getValue(this.questionItem.prop);
    if (this.questionItem.iterateLinkLabel) {
      this.linkLabel = this.questionItem.iterateLinkLabel;
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.updateProgressAndSubscriptions();
  }

  ngAfterViewInit() {
    this.viewChildren.changes.subscribe(() => {
      if (this.removeIndex !== -1) {
        this.removeIndex = -1;
        this.arrayProp = this.getValue(this.questionItem.prop);
        this.activeElement = this.arrayProp.length ? this.arrayProp.length - 1 : 0; // by default open the last element in iterator
      }
    });
  }

  get enableAddAnother(): boolean {
    const array = this.arrayProp;
    return array.length < 10;
  }

  resetValue() {}

  updateFromModel() {}

  toggleElement(element: number): void {
    this.activeElement = this.activeElement === element ? -1 : element;
  }

  isActive(element: number): boolean {
    return this.activeElement === element;
  }

  add(prop: string, arrayType: string, addFuncSuffix: boolean) {
    this.addIterateElement(prop, arrayType, addFuncSuffix);
    this.activeElement = this.arrayProp.length - 1;
    this.arrayProp = this.getValue(this.questionItem.prop);
    this.updateProgressAndSubscriptions();
  }

  remove(prop: string, index: number, removeFuncSuffix: boolean): void {
    this.removeIndex = index;
    const toRemove = [];
    this.viewChildren['_results'].forEach((appQuestion: ApplicationFormQuestionTraverseComponent) => {
      const instance: BaseFormComponent = appQuestion.dynamicComponent.currentComponent.instance;
      if (instance.loopIndex === index) {
        toRemove.push(appQuestion);
      } else {
        instance.conditionalDestroyBlock = true;
      }
    });

    toRemove.forEach((instance) => {
      // When removing an item from a set of iterate-collects,
      // make sure to reduce the maxIndex to one less than it previously was
      instance.childQuestion.loopIndex--;
      instance.remove();
    });
    this.informationModalService.showMessageIfPresent(prop, index);
    this.removeIterateElement(prop, index, removeFuncSuffix);
    this.updateProgressAndSubscriptions();
  }
}
